<ng-container>
  @if (group$ | async; as group) {
    <!-- Multiple Lead Seller Groups Layout -->
    @if (isSellerAssociatedToMultipleLeadSellerGroup) {
      <app-search-filter-section
        [title]="group.groupName"
        [tagName]="tagName"
        [open]="open"
        variant="link"
        [scrollable]="false"
        (openChange)="open = !open">

        <!-- Selected Count Badge -->
        <span
          title-right
          class="badge badge-pill badge-light ms-auto"
          [attr.aria-label]="(selectedMemberCount$ | async) + ' members selected'">
          {{ selectedMemberCount$ | async }}
        </span>

        <!-- Group Selection Content -->
        <ng-container *ngTemplateOutlet="groupSelectionContent; context: {
          group: group,
          isMultiple: true
        }"></ng-container>
      </app-search-filter-section>
    }

    <!-- Single Lead Seller Group Layout -->
    @if (isSellerAssociatedToSingleLeadSellerGroup) {
      <div class="single-group-container">
        <ng-container *ngTemplateOutlet="groupSelectionContent; context: {
          group: group,
          isMultiple: false
        }"></ng-container>
      </div>
    }
  }

  <!-- Shared Group Selection Template -->
  <ng-template #groupSelectionContent let-group="group" let-isMultiple="isMultiple">
    <fieldset class="dealer-group-fieldset">

      <!-- Select All Group Checkbox -->
      <div class="custom-control custom-checkbox mt-1">
        <input
          type="checkbox"
          class="custom-control-input"
          [id]="getGroupCheckboxId(group.uuid, isMultiple)"
          [checked]="isGroupSelected$ | async"
          [appTrack]="getGroupTrackingConfig(group.groupName)"
          [attr.data-test-id]="getGroupTestId(isMultiple)"
          [attr.aria-describedby]="getGroupDescriptionId(group.uuid, isMultiple)"
          (change)="handleGroupToggle(isMultiple)" />

        <label
          class="custom-control-label ms-2"
          [for]="getGroupCheckboxId(group.uuid, isMultiple)">
          @if (isMultiple) {
            {{ translations.labelAll }} {{ group.groupName }}
          } @else {
            {{ group.groupName }}
          }
        </label>
      </div>

      <!-- Members List -->
      <ul
        class="list-unstyled ps-3 members-list"
        role="group">

        @for (member of filteredMembers$ | async; track member.oeUuid; let index = $index) {
          <li class="my-3 pt-1">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="getMemberCheckboxId(member.oeUuid, isMultiple)"
                [checked]="member.isSelected"
                [appTrack]="getMemberTrackingConfig(member.oeName)"
                [attr.data-test-id]="'app-dealer-group-section-e-member-checkbox-' + index"
                [attr.aria-describedby]="getMemberDescriptionId(member.oeUuid)"
                (change)="toggleMember(member.oeUuid)" />

              <label
                class="custom-control-label ms-2"
                [for]="getMemberCheckboxId(member.oeUuid, isMultiple)">
                {{ member.oeName }}
              </label>

            </div>
          </li>
        }
      </ul>
    </fieldset>
  </ng-template>
</ng-container>



